import { ProfileCardTitle } from 'ui/ProfileCard';
import { NotepadIcon } from 'ui/icons';
import { CompactText } from 'ui/CompactText';
import { NavLink } from 'react-router';

import { useProfileModeration } from 'hooks/useProfileModeration';
import { useTutorTrustScore } from 'hooks/useTutorTrustScore';

import styles from './TutorDailyResponsesCard.module.scss';

export const TutorDailyResponsesCard = () => {
  const { data, isLoading, isError } = useTutorTrustScore();
  const { isApproved } = useProfileModeration();
  const daily = data?.daily_responses;

  if (isLoading || isError || !data || !daily) {
    return null;
  }

  return (
    <section className={styles.card} aria-label='Отклики на заявки'>
      <ProfileCardTitle className={styles.title} icon={<NotepadIcon />}>Отклики на заявки</ProfileCardTitle>
      <div className={styles.stats}>
        <div className={styles.stat}>
          <p className={styles.label}>Лимит</p>
          <p className={styles.value}>{daily.responses_max}</p>
        </div>
        <div className={styles.stat}>
          <p className={styles.label}>Использовано</p>
          <p className={styles.value}>{daily.responses_used}</p>
        </div>
        <div className={styles.stat}>
          <p className={styles.label}>Доступно</p>
          <p className={styles.value}>{daily.responses_remaining}</p>
        </div>
      </div>
      {!isApproved ? (
        <NavLink to='/teacher/edit' className={styles.action}>
          Продолжить заполнение профиля
        </NavLink>
      ) : (
        <NavLink to='/teacher/search' className={styles.action}>
          Посмотреть заявки
        </NavLink>
      )}
      <CompactText className={styles.hint} tone={'info'}>
        Число берется из профиля. Это не тариф и не срок восстановления.
      </CompactText>
    </section>
  );
};
